import { gql } from "@apollo/client";
export const CREATE_FAQ = gql`
 mutation CreateFAQ($question:String!,$answer:String!) {
    createFAQ(question: $question, answer: $answer) {
       error
        data {
            answer
            id
            question
        }
    }
}
`;

export const UPDATE_FAQ = gql`
  mutation UpdateFAQ($question: String!, $answer: String!, $id: ID!) {
    updateFAQ(question: $question, answer: $answer, id: $id) {
      error
      data {
        answer
        id
        question
      }
    }
  }
`;

export const DELETE_FAQ = gql`
  mutation DeleteFAQ($id: ID!) {
    deleteFAQ(id: $id) {
      data
      error
    }
  }
`;
